module.exports = __webpack_public_path__ + "static/media/placeholder.a0d53e8d.webp";